import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BasketDiscountsComponent } from './basket-discounts.component';

const routes: Routes = [
  {
    path: '',
    component: BasketDiscountsComponent,
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BasketDiscountsRoutingModule {}
